import { updateLiquidityOneOffCashflowItemSettings } from '../../../app/api/generated/client';
import { queryKeys } from '../query-keys';
import { useLiquiditySettingsMutation } from './use-liquidity-settings-mutation';

export const useUpdateLiquidityOneOffCashflowItemSettings = () =>
    useLiquiditySettingsMutation({
        mutationFn: (payload) => updateLiquidityOneOffCashflowItemSettings({ body: payload, path: { id: payload.id! } }).then((result) => result.data!),
        settingsQueryKey: queryKeys.liquidityOneOffCashflowSettings,
        scope: 'item',
    });
